exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control{\r\n\r\nborder-radius: 0rem !important;\r\nwidth:100%;\r\nborder-bottom: 2px solid #0e0e0ed1;\r\n}\r\n.alert {\r\n    position: relative;\r\n    padding: 1px !IMPORTANT;\r\n    margin-bottom: 0px !IMPORTANT;\r\n    border: 1px solid transparent !IMPORTANT;\r\n    border-radius: 1px !IMPORTANT;\r\n    color:red;\r\n}\r\n.form-group {\r\n    margin-bottom: 1rem !important;\r\n    height: 65px !important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/standing-instruction/standing-instruction.component.css
// module id = ../../../../../src/app/standing-instruction/standing-instruction.component.css
// module chunks = main